import React from 'react'
import Spacer from 'components/Spacer'
import styled from 'styled-components'

const Label = ({ text, size, value, tokenLevel, errText }) => {
  return (
    <>
      {tokenLevel ? (
        <>
          <StyledTokenLabel size={size}>
            {value ? `${text}${' '}${value}` : `${errText}`}
          </StyledTokenLabel>
          <Spacer />
        </>
      ) : (
        <StyledLabel size={size}>{text}</StyledLabel>
      )}
    </>
  )
}
const StyledLabel = styled.div`
  color: ${(props) => props.theme.color.grey[400]};
  font-size: ${(props) => (props.size ? props.size : 18)}px;
`

const StyledTokenLabel = styled.div`
  color: ${(props) => props.theme.color.grey[500]};
  font-size: ${(props) => (props.size ? props.size : 18)}px;
  width: 350px;
`

export default Label
